/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/require-default-props */
import React from 'react';
import {
  Select, MenuItem, Typography, IconButton, Tooltip, CircularProgress,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import type { LeaseDocument, DocumentType } from './types';
import { DOCUMENT_TYPE_LABELS, DOCUMENT_TYPE_STYLES } from './types';

interface DocumentCardProps {
  document: LeaseDocument;
  leaseId: number;
  onTypeChange: (documentId: number, newType: DocumentType) => void;
  onDelete: (documentId: number) => void;
  canDelete: boolean;

  /** True while the upload POST is in-flight (before the API refetch reflects is_processed=false) */
  isUploading?: boolean;
}

export default function DocumentCard({
  document: doc,
  leaseId,
  onTypeChange,
  onDelete,
  canDelete,
  isUploading = false,
}: DocumentCardProps): JSX.Element {
  const style = DOCUMENT_TYPE_STYLES[doc.document_type] || DOCUMENT_TYPE_STYLES.other;

  const formatDate = (dateStr: string | null): string => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const handleOpenPdf = (): void => {
    if (doc.pdf_url) {
      const baseUrl = process.env.REACT_APP_BASE_URL ?? '';
      const fullUrl = doc.pdf_url.startsWith('http') ? doc.pdf_url : `${baseUrl}${doc.pdf_url}`;
      window.open(fullUrl, '_blank');
    }
  };

  // Show overlay if:
  // - isUploading: the POST is in-flight (before Celery even starts, progress still 0)
  // - !is_processed && progress > 0: Celery has started and is actively working
  // Do NOT show overlay for legacy docs where is_processed=false but progress=0 (never processed field set)
  const isProcessing = isUploading || (!doc.is_processed && doc.progress > 0);
  let progressLabel = 'Processing...';
  if (isUploading) {
    progressLabel = 'Uploading...';
  } else if (doc.progress > 0) {
    progressLabel = `Processing... ${doc.progress}%`;
  }

  return (
    <div
      style={{
        position: 'relative',
        border: '1px solid #E5E7EB',
        borderRadius: '8px',
        padding: '12px 16px',
        marginBottom: '8px',
        backgroundColor: '#fff',
      }}
    >
      {isProcessing && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(255,255,255,0.88)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            paddingLeft: '16px',
            gap: '10px',
            zIndex: 1,
          }}
        >
          <CircularProgress size={16} sx={{ color: '#00CFA1', flexShrink: 0 }} />
          <div>
            <span
              style={{
                backgroundColor: DOCUMENT_TYPE_STYLES[doc.document_type]?.bg || '#F3F4F6',
                color: DOCUMENT_TYPE_STYLES[doc.document_type]?.text || '#6B7280',
                fontSize: '11px',
                fontWeight: 600,
                padding: '2px 8px',
                borderRadius: '4px',
                display: 'inline-block',
                marginBottom: '3px',
              }}
            >
              {DOCUMENT_TYPE_LABELS[doc.document_type] || doc.document_type}
            </span>
            <Typography variant='body2' style={{ color: '#6B7280', fontSize: '12px' }}>
              {progressLabel}
            </Typography>
          </div>
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
          <DescriptionIcon style={{ color: '#9CA3AF', fontSize: '20px' }} />
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <span
                style={{
                  backgroundColor: style.bg,
                  color: style.text,
                  fontSize: '11px',
                  fontWeight: 600,
                  padding: '2px 8px',
                  borderRadius: '4px',
                }}
              >
                {DOCUMENT_TYPE_LABELS[doc.document_type] || doc.document_type}
              </span>
              {doc.effective_date && (
                <Typography variant='caption' style={{ color: '#6B7280' }}>
                  Effective: {formatDate(doc.effective_date)}
                </Typography>
              )}
            </div>
            <Typography
              variant='body2'
              style={{ color: '#374151', fontSize: '13px', cursor: doc.pdf_url ? 'pointer' : 'default' }}
              onClick={handleOpenPdf}
            >
              {doc.original_filename || 'document.pdf'}
            </Typography>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Select
            value={doc.document_type}
            onChange={(e) => onTypeChange(doc.id, e.target.value as DocumentType)}
            size='small'
            variant='outlined'
            sx={{
              fontSize: '12px',
              minWidth: '100px',
              height: '32px',
              borderRadius: '6px',
              boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#D1D5DB',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#9CA3AF',
              },
              '& .MuiSelect-select': {
                padding: '4px 28px 4px 10px',
                fontSize: '12px',
              },
            }}
          >
            <MenuItem value='base_lease'>Base Lease</MenuItem>
            <MenuItem value='amendment'>Amendment</MenuItem>
            <MenuItem value='other'>Other</MenuItem>
          </Select>
          {doc.pdf_url && (
            <Tooltip title='Open PDF'>
              <IconButton size='small' onClick={handleOpenPdf}>
                <OpenInNewIcon style={{ fontSize: '16px' }} />
              </IconButton>
            </Tooltip>
          )}
          {doc.download_url && (
            <Tooltip title='Download PDF'>
              <IconButton size='small' onClick={() => { window.location.href = `${process.env.REACT_APP_BASE_URL}${doc.download_url!}`; }}>
                <FileDownloadOutlinedIcon style={{ fontSize: '16px' }} />
              </IconButton>
            </Tooltip>
          )}
          {canDelete && (
            <Tooltip title='Remove document'>
              <IconButton size='small' onClick={() => onDelete(doc.id)}>
                <DeleteOutlineIcon style={{ fontSize: '16px', color: '#EF4444' }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
}
